import React from 'react';
import { useCountdown } from '../contexts/CountdownContext';
export function StickyBar() {
  const {
    label
  } = useCountdown();
  return <div className="sticky top-0 z-50 flex h-11 items-center justify-center px-3 text-white sm:h-12" style={{
    background: 'linear-gradient(90deg, #c9a84c 0%, #1a4a2e 100%)'
  }} data-id="element-106" data-mp="12m0kzos9ke5r">
      <p className="flex items-center gap-2 truncate text-[12px] font-bold tracking-tight sm:text-[13px]" data-id="element-107" data-mp="suwap2dj9hh9">
        <span className="hidden sm:inline" data-id="element-108" data-mp="ny5umf1qalvu">
          🔥 OFERTA DE LANZAMIENTO — El Súper Bono de Numerología se incluye GRATIS — Expira en:
        </span>
        <span className="sm:hidden" data-id="element-109" data-mp="evefa45qf5yx">🔥</span>
        <span className="rounded bg-black/35 px-2 py-0.5 font-mono tabular-nums text-gold-light" data-id="element-110" data-mp="ewg193oadcvf">
          {label}
        </span>
        <span className="font-black" data-id="element-111" data-mp="9z62gxf0boux">— $9.99 USD</span>
      </p>
    </div>;
}